import axios from '../axios'

export default class ConfirmationSMSLeader{
    async GetInformationOs(id_attendance){
        let res = await axios.get("Attendance/get-attendance-by-id?id_attendance="+id_attendance);
        return res.data;
    }

    async UpdateAttendanceLiberationLeader(id_attendance, decision_leader){
        let res = await axios.post("Attendance/update-attendance-permission-leader", {id_referencia: id_attendance, decisao_lider: decision_leader});
        return res.data;
    }


    
}